/* eslint-disable */
import Flourish from "@flourish/live-api";
import { isEmpty } from "validate.js";

const API_KEY =
  "r1kaFHCTPkl1PNGIBhcB2pL4lW4bkb1_4luLjdYK0ZZXkMMHtDzDBoFr9WAws6-1";

const initializeFlourish = (
  containerId,
  baseVisualizationId,
  flourishData,
  apiKey = API_KEY,
) => {
  const container = document.querySelector(containerId);
  if (container) {
    if (containerId != "#word-cloud") {
      new Flourish.Live({
        api_key: apiKey,
        container: containerId,
        base_visualisation_id: baseVisualizationId,
        state: flourishData.state,
        data: flourishData.data,
        bindings: flourishData.bindings,
      });
    } else {
      new Flourish.Live({
        api_key: apiKey,
        container: containerId,
        base_visualisation_id: baseVisualizationId,
        data: flourishData.data,
      });
    }
  }
};

if (document.getElementById("scam-1")) {
  const fccMethod = apiData.flourishScamSection;
  if (!isEmpty(fccMethod.byMethod)) {
    if (fccMethod) {
      initializeFlourish("#scam-1", "19421083", fccMethod.byMethod);
    }
  }
}

if (document.getElementById("scam-2")) {
  if (apiData.flourishScamSection) {
    const fccType = apiData.flourishScamSection;
    if (!isEmpty(fccType.byType)) {
      if (fccType) {
        initializeFlourish("#scam-2", "19421083", fccType.byType);
      }
    }
  }
}

if (document.getElementById("scam-3")) {
  const fccIssue = apiData.flourishScamSection;
  if (!isEmpty(fccIssue.byIssue)) {
    if (fccIssue) {
      initializeFlourish("#scam-3", "19421083", fccIssue.byIssue);
    }
  }
}

if (document.getElementById("demographic-1")) {
  const demographicsMedianIncome = apiData.flourishDemographic;
  if (!isEmpty(demographicsMedianIncome.byMedianIncome)) {
    if (demographicsMedianIncome) {
      initializeFlourish(
        "#demographic-1",
        "19448374",
        demographicsMedianIncome.byMedianIncome,
      );
    }
  }
}

if (document.getElementById("demographic-2")) {
  const demographicsRacial = apiData.flourishDemographic;
  if (!isEmpty(demographicsRacial.byRace)) {
    if (demographicsRacial) {
      initializeFlourish(
        "#demographic-2",
        "19449140",
        demographicsRacial.byRace,
      );
    }
  }
}

if (document.getElementById("demographic-3")) {
  const demographicsPopulationGrowth = apiData.flourishDemographic;
  if (!isEmpty(demographicsPopulationGrowth.byPopulation)) {
    if (demographicsPopulationGrowth) {
      initializeFlourish(
        "#demographic-3",
        "19450691",
        demographicsPopulationGrowth.byPopulation,
      );
    }
  }
}

if (document.getElementById("demographic-4")) {
  const demographicsWorkforce = apiData.flourishDemographic;
  if (!isEmpty(demographicsWorkforce.byWorkForce)) {
    if (demographicsWorkforce) {
      initializeFlourish(
        "#demographic-4",
        "19449037",
        demographicsWorkforce.byWorkForce,
      );
    }
  }
}

if (document.getElementById("word-cloud")) {
  console.log(wordCloud);
  if (wordCloud) {
    initializeFlourish("#word-cloud", "18908117", wordCloud);
  }
}

if (document.getElementById("map-area-code")) {
  const map = apiData.map;
  new Flourish.Live({
    api_key: API_KEY,
    container: "#map-area-code",
    base_visualisation_id: "19381119",
    data: {
      events: [],
      lines: [],
      regions: [],
      regions_map: [
        ["geometry", "areaCode"],
        [map.data.regions_map[1], map.data.regions_map[2]],
      ],
    },
  });
}

if (document.getElementById("map-area-codes")) {
  new Flourish.Live({
    api_key: API_KEY,
    container: "#map-area-codes",
    base_visualisation_id: "19788065",
    // data: {
    //   events: [],
    //   lines: [],
    //   regions: [],
    //   regions_map: [
    //     ['geometry', 'areaCode'],
    //     [map.data.regions_map[1], map.data.regions_map[2]],
    //   ],
    // },
  });
}
